import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
declare const window: any;

@Injectable()
export class RefreshTokenStatusInterceptor implements HttpInterceptor {
  constructor() {
    window.activeRequests = window.activeRequests || false;
    window.lastApiCallTime = window.lastApiCallTime || 0;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('users/token/refresh')) {
      window.activeRequests = true;
      window.lastApiCallTime = new Date().getTime();
    }
    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && request.url.includes('users/token/refresh')) {
            window.activeRequests = false;
          }
        },
        error: () => {
          if (request.url.includes('users/token/refresh')) {
            window.activeRequests = false;
          }
        },
      }),
    );
  }
}
